// extracted by mini-css-extract-plugin
export var arrow = "_2k-6";
export var changeItem = "_2k-3";
export var changesHeader = "_2k-1";
export var changesList = "_2k-2";
export var container = "_2k-0";
export var pathLabel = "_2k-4";
export var value = "_2k-7";
export var valuesContainer = "_2k-5";